<app-access-manager [namespace]="namespace">
<div>
    <app-filterable-table
        #transactionsTable
        [tableView]="transactionsTableView"
        [title]="'Recent Transactions'"
        (selectedRecord)="handleTransactionSelected($event)"
    ></app-filterable-table>
</div>
</app-access-manager>